export const NAVIGATION_TAB_CHANGED = 'NAVIGATION_TAB_CHANGED';



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/navTab/events.js